<template>
  <div id="register-form">
    <Form
      :header="header"
      :schema="schema"
      :model="model"
      :buttons="buttons"
      :options="options"
      :messages="messages"
      @form_submit="form_submit"
      @button_click="button_click"
    ></Form>
  </div>
</template>

<script>
import Vue from "vue";
import Form from "../../components/Form.vue";
import VueFormGenerator from "vue-form-generator";
import { get_validator_messages } from "../../validators/locale_pl";

var validator_messages = get_validator_messages();

export default {
  name: "Register",
  components: {
    Form
  },
  data() {
    return {
      buttons: [
        {
          name: "login",
          style_classes: "float-right mb-1",
          buttons: [
            {
              label: "Zaloguj się",
              variant: "primary",
              type: "button",
              name: "login",
              icon: "shield-lock-fill"
            },
            {
              label: "Zarejestruj się",
              variant: "success",
              type: "submit",
              name: "register",
              icon: "person-plus-fill"
            }
          ]
        }
      ],
      header: {
        title: "Rejestracja",
        icon: "person-plus-fill"
      },
      model: {
        email: null,
        password: null,
        givem_name: null,
        family_name: null,
        phone: null,
        regulations_acceptance: null,
        personal_data_processing: null
      },
      messages: [],
      schema: {
        groups: [
          {
            styleClasses: "form-row",
            fields: [
              {
                styleClasses: "col-lg-6",
                type: "input",
                inputType: "email",
                label: "Email",
                model: "email",
                required: true,
                validator: [
                  VueFormGenerator.validators.email.locale(validator_messages)
                ]
              },
              {
                styleClasses: "col-lg-6",
                type: "input",
                inputType: "password",
                label: "Hasło",
                model: "password",
                help:
                  "Minimalna długość hasła wynosi osiem znaków. Hasło musi zawierać przynajmniej jedną dużą i małą literę alfabetu. Hasło musi zawierać przynajmniej jeden znak specjalny i liczbę.",
                required: true,
                autocomplete: true,
                validator: [
                  VueFormGenerator.validators.required.locale(
                    validator_messages
                  )
                ]
              },
              {
                styleClasses: "col-lg-6",
                type: "input",
                inputType: "text",
                label: "Imię",
                model: "given_name",
                required: true,
                validator: [
                  VueFormGenerator.validators.required.locale(
                    validator_messages
                  )
                ]
              },
              {
                styleClasses: "col-lg-6",
                type: "input",
                inputType: "text",
                label: "Nazwisko",
                model: "family_name",
                required: true,
                validator: [
                  VueFormGenerator.validators.required.locale(
                    validator_messages
                  )
                ]
              },
              {
                styleClasses: "col-lg-12",
                type: "input",
                inputType: "text",
                label: "Telefon",
                model: "phone"
              }
            ]
          },
          {
            fields: [
              {
                styleClasses: "col-lg-12",
                type: "checkbox",
                label: "Akceptuje regulamin lorem ipsum dolum",
                model: "regulations_acceptance",
                default: false,
                required: true,
                validator: [
                  VueFormGenerator.validators.required.locale(
                    validator_messages
                  )
                ]
              },
              {
                styleClasses: "col-lg-12",
                type: "checkbox",
                label: "Zgoda na przetwarzanie danych osobowych",
                model: "personal_data_processing",
                default: false,
                required: true,
                validator: [
                  VueFormGenerator.validators.required.locale(
                    validator_messages
                  )
                ]
              }
            ]
          }
        ]
      },
      options: {
        validateAfterChanged: true,
        validateAsync: true
      }
    };
  },
  methods: {
    button_click: function(button_name) {
      if (button_name == "login") {
        this.$router.push({ name: "Login" });
      }
    },
    form_submit: function(model) {
      var attributes_list = [
        {
          Name: "family_name",
          Value: model.family_name
        },
        {
          Name: "given_name",
          Value: model.given_name
        }
      ];
      if (model.phone) {
        attributes_list.push({
          Name: "phone_number",
          Value: model.phone
        });
      }
      Vue.CognitoAuth.register(
        model.email,
        model.password,
        attributes_list,
        this.register_success,
        this.register_failure
      );
    },
    register_failure: function(err) {
      console.log("Register failure:", err);
      this.messages = [];
      this.messages = [
        {
          label: err,
          variant: "danger"
        }
      ];
    },
    register_success: function() {
      this.$localStorage.set("register_success", this.model.email);
      this.$router.push({ name: "ConfirmRegistration" });
    }
  }
};
</script>

<style>
@media (min-width: 768px) {
  #register-form .form-container {
    max-width: 600px;
  }
}
</style>
